import type { SlideImage } from "yet-another-react-lightbox";
export function Gallery2016(){


const slides: SlideImage[] = [
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_001.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_001.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_002.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_002.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_003.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_003.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_004.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_004.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_005.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_005.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_006.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_006.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_007.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_007.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_008.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_008.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_009.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_009.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_010.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_010.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_011.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_011.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_012.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_012.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_013.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_013.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_014.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_014.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_015.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_015.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_016.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_016.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_017.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_017.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_018.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_018.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_019.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_019.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_020.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_020.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_021.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_021.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_022.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_022.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_023.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_023.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_024.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_024.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_025.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_025.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_026.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_026.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_027.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_027.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_028.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_028.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_029.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_029.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_030.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_030.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_031.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_031.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_032.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_032.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_033.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_033.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_034.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_034.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_035.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_035.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_036.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_036.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_037.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_037.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_038.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_038.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_039.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_039.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_040.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_040.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_041.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_041.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_042.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_042.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_043.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_043.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_044.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_044.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_045.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_045.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_046.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_046.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_047.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_047.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_048.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_048.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_049.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_049.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_050.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_050.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_051.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_051.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_052.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_052.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_053.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_053.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_054.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_054.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_055.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_055.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_056.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_056.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_057.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_057.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_058.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_058.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_059.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_059.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_060.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_060.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_061.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_061.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_062.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_062.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_063.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_063.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_064.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_064.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_065.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_065.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_066.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_066.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_067.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_067.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_068.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_068.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_069.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_069.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_070.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_070.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_071.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_071.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_072.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_072.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_073.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_073.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_074.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_074.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_075.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_075.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_076.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_076.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_077.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_077.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_078.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_078.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_079.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_079.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_080.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_080.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_081.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_081.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_082.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_082.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_083.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_083.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_084.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_084.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_085.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_085.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_086.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_086.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_087.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_087.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_088.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_088.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_089.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_089.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_090.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_090.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_091.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_091.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_092.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_092.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_093.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_093.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_094.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_094.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2016/LRG_095.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2016/SML_095.jpg"
        }
      ];

     return slides;
} 
